<template>
  <div>
    <div class="mt-element-list">
                                        <div class="mt-list-head list-default ext-1 bg-green-sharp">
                                            <div class="row">
                                                <div class="col-xs-8">
                                                    <div class="list-head-title-container">
                                                        <h3 class="list-title uppercase sbold" style="color:white">Liste des Bureaux</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-list-container list-default ext-1">
                                            <div class="mt-list-title uppercase">Bureaux
                                                <span class="badge badge-default pull-right bg-hover-green-jungle">
                                                    <a class="font-white" href="javascript:;">
                                                        <i class="fa fa-plus"></i>
                                                    </a>
                                                </span>
                                            </div>
                                            <ul>
                                                <li v-for='bureau in bureaux' class="mt-list-item done">
                                                    <div class="list-icon-container">
                                                        <a href="javascript:;">
                                                            <i class="icon-check"></i>
                                                        </a>
                                                    </div>
                                                    <div class="list-item-content">
                                                        <h3 class="uppercase">
                                                            <a href="#">{{bureau.name}}</a>
                                                        </h3>
                                                        <i class="fa fa-times pull-right" style='margin-top:-7px' @click='deleteBureau(bureau.name)'></i>
                                                        <p>{{bureau.url}}</p>
                                                    </div>
                                                </li>
                                                <li class="mt-list-item done">
                                                    <div class="form-group form-inline">
                                                      <div class="list-icon-container">
                                                        <a href="javascript:;">
                                                        </a>
                                                      </div>
                                                      <div class="list-item-content">
                                                          <h3 class="text-center">
                                                              <input placeholder='Nom du Bureau'class=""type="text" name="" value="" v-model='bureau.name'>
                                                              <input placeholder='Url du Site'class=""type="text" name="" value="" v-model='bureau.url'>
                                                              <button type="button"class="btn btn default" @click='newBureau()'>Ajouter</button>
                                                          </h3>
                                                      </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
  </div>
</template>

<script>
export default {
  props: ['bureaux'],
  data(){
    return{
      bureau:{ name:'', url:''}
    }
  },
  methods:{
    newBureau(){
      this.bureaux.push(this.bureau)
    },
    deleteBureau(name){
      console.log(this.bureaux.indexOf(name) != -1);
      console.log(this.bureaux.length);
    }
  }
}
</script>

<style lang="css">
</style>
